<ion-segment [value]="segment"
             mode="md"
             color="primary">
    <ion-segment-button [ngClass]="{ 'active': segment === tab.segment }"
                        id="{{ tab.value }}"
                        *ngFor="let tab of tabs;"
                        [value]="tab.value"
                        matTooltip="{{ tab.tooltip }}"
                        (click)="navigate(tab)"
                        [disabled]="tab.disabled"
                        [hidden]="tab.hidden">
        <ion-label *ngIf="!tab.icon">{{ tab.label }}</ion-label>
        <ion-label class="ion-hide-lg-down"
                   *ngIf="tab.icon">{{ tab.label }}</ion-label>
        <ion-icon class="ion-hide-lg-up"
                  *ngIf="tab.icon"
                  name="{{ tab.icon }}"></ion-icon>
    </ion-segment-button>
</ion-segment>
<ion-card class="ion-no-margin">
    <ion-card-content class="card-content">
        <ng-content></ng-content>
    </ion-card-content>
</ion-card>
